import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { is } from 'ramda';
import React from 'react';

import { CONSTANTS } from '../../../../core/config/constants';

const COMPANY_ADDRESS_FIELDS = ['address', 'city', 'country', 'postalCode', 'type'];

const CompanyAddressCellRenderer: React.FC<ICellRendererParams> = ({ data }) => {
  const address: string[] = [];

  if (data && is(Object, data?.companyInfo?.address)) {
    COMPANY_ADDRESS_FIELDS.forEach((key) => {
      if (data.companyInfo.address[key]) {
        address.push(data.companyInfo.address[key]);
      }
    });
  }

  return <>{address.join(CONSTANTS.RENDERER_ARRAY_SEPARATOR)}</>;
};

export default CompanyAddressCellRenderer;
